import * as React from "react";
import {cs} from "../../../../../../../../../../react/chain-services";
import {consumeContext} from "../../../../../../../../../../react/context";
import {stateChangeNestedValue} from "../../../../../../../../../../react/state-change-nested-value";
import "./zip-code.scss";
import {UseState} from "../../../../../../../../../../react/use-state";
import {Form2} from "../../../../../../../../../../react/cs-form-2/form2";
import {required} from "../../../../../../../../../../react/cs-form-2/validators/required";
import {chain} from "../../../../../../../../../../utils/fs";
import {cx} from "emotion";
import {bindInput} from "../../../../../../../../../../react/bind-input";
import {isDevQuan} from "../../../../../../../../../debug/is-dev-quan";
import {ErrorHighlighter} from "../../../../../../../../../light/error-highlighter";
import {Static2} from "../../../../../../../../../../react/static-2";
import {scrollIntoView} from "../../../../../../../../../light/scroll-into-view";
import {CheckboxLine} from "heavy/mailing-ui/create-mailing-list-modal/types/demographics/step-2-customize/form/checkbox-line/checkbox-line";

export const ZipCode = ({next}) => cs(
    consumeContext("company"),
    ["apiError", (_, next) => UseState({next})],
    ["data", ({apiError}, next) => UseState({
        initValue: !isDevQuan() ? {
            zipCodes: "",
            filters: {
                addressTypesSelection: "res",
                excludeRural: false,
            }
        } : {
            zipCodes: "76110,76137",
            filters: {
                addressTypesSelection: "res",
                excludeRural: false,
            }
        },
        next: ({value, onChange}) => next({
            value,
            onChange: (v)=>{
                onChange(v);
                apiError.value && apiError.onChange(null);
            }
        }),
    })],
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ["form", ({data}, next) => Form2({
        data,
        showErrors: true,
        fields: [
            {
                path: ["zipCodes"],
                validators: [required],
            }
        ],
        next,
    })],
    ({company, form, eh, domRef, apiError, data}) => next({
        valid: form.valid,
        getSearchRequest: () => data.value,
        highlightErrors: () => {
            eh.start();
            scrollIntoView(domRef.get());
        },
        handleApiError: (error) => {
            apiError.onChange({error});
            eh.start();
            scrollIntoView(domRef.get());
        },
        render: ({showErrors}) => (
            <div className="zip-code-4zr">
                <div className="label" xd-qa-type="label" xd-qa-name="Neighborhood Search Enter Zip Codes">
                    Enter zip codes you want to target
                </div>

                {chain(
                    form.field("zipCodes"),
                    (field) => ({
                        ...field,
                        error: showErrors && field.error,
                    }),
                    (field) => (
                        <input {...{
                            ref: domRef.set,
                            className: cx({hasError: field.error}, eh.css),
                            placeholder: "Separate multiple zip codes with a comma",
                            ...bindInput(field.state),
                            onBlur: () => field.state.change((_) => _?.split(/[,\s]+/).join(",")),
                            "xd-qa-type": "text_field",
                            "xd-qa-name": "Neighborhood Search Enter Zip Codes"
                        }}/>
                    )
                )}

                {apiError.value && (
                    <div className="error">
                        {apiError.value.error}
                    </div>
                )}

                <div className="label" xd-qa-type="label" xd-qa-name="Neighborhood Search Recipient Options">
                    Additional Recipient Options
                </div>
                <div className="options">
                    <div className="option">
                        {CheckboxLine({
                            state: {
                                value: data.value?.filters?.addressTypesSelection === "all",
                                onChange: () => stateChangeNestedValue(data, ["filters", "addressTypesSelection"], (_) => _ === "all" ? (
                                    "res"
                                ) : (
                                    "all"
                                )),
                            },
                            text: "Businesses",
                            xdQaName: "Neighborhood Search Businesses",
                        })}
                    </div>
                    <div className="option">
                        {CheckboxLine({
                            state: {
                                value: !data.value?.filters?.excludeRural,
                                onChange: () => stateChangeNestedValue(data, ["filters", "excludeRural"], (_) => !_),
                            },
                            text: "Residential Rural Routes",
                            xdQaName: "Neighborhood Search Residential Rural Routes",
                        })}
                    </div>
                </div>

                <div className="clear">
                    <a {...{
                        onClick: () => data.onChange({
                            zipCodes: "",
                            filters: {
                                addressTypesSelection: "res",
                                excludeRural: false,
                            }
                        }),
                        "xd-qa-type": "link",
                        "xd-qa-name": "Neighboorhood Search Reset"
                    }}>
                        Reset
                    </a>
                </div>
            </div>
        ),
    }),
);

